<template>
  <hm-content title="促销详情">
    <div class="detail-container">
      <div class="activity mb20">
        <div class="caption">创建促销</div>
        <ul>
          <li class="flex">
            <div class="title">促销活动</div>
            <div class="content">
              {{ details.basicConfigInfo.promotionName }}
            </div>
          </li>
          <li class="flex" v-if="couponLevelList.length">
            <div class="title">促销层级</div>
            <div class="content">
              {{ pasLevelName }}
            </div>
          </li>
          <li class="flex">
            <div class="title">基础价&nbsp;&nbsp;&nbsp;</div>
            <div class="content">
              <span
                v-show="details.basicConfigInfo.assignPriceType === 'promotion'"
                >会员价</span
              >
              <span
                v-show="details.basicConfigInfo.assignPriceType === 'retail'"
                >零售价</span
              >
            </div>
          </li>
          <li
            class="flex"
            v-if="details.basicConfigInfo.runningTimeType === 'all'"
          >
            <div class="title">优惠时间</div>
            <div class="content primary" v-if="details.pasCalendars">
              {{ details.pasCalendars.promotionStartTime }}至{{
                details.pasCalendars.promotionEndTime
              }}
            </div>
          </li>
          <li
            class="flex"
            v-if="details.basicConfigInfo.runningTimeType === 'special'"
          >
            <div class="title">优惠时间</div>
            <div class="content primary">
              {{ details.dateConfigInfo.promotionStartDate }}至{{
                details.dateConfigInfo.promotionEndDate
              }}
            </div>
          </li>
          <li
            class="flex"
            v-if="details.basicConfigInfo.runningTimeType === 'special'"
          >
            <div class="title">特定时段</div>
            <div>
              <div
                class="content primary"
                v-if="details.dateConfigInfo.dateType === 'day'"
              >
                <div>每{{ details.dateConfigInfo.dateValue }}天生效</div>
              </div>
              <div class="content primary">
                <div
                  class="flex"
                  v-if="details.dateConfigInfo.dateType === 'week'"
                >
                  每
                  <div
                    class="mr10"
                    v-for="(v, i) in details.dateConfigInfo.dateValues"
                    :key="i"
                  >
                    {{ "周" + v }}
                  </div>
                  生效
                </div>
                <div
                  class="flex"
                  v-if="details.dateConfigInfo.dateType === 'month'"
                >
                  每月
                  <div
                    class="mr10"
                    v-for="(v, i) in details.dateConfigInfo.dateValues"
                    :key="i"
                  >
                    {{ v }}
                  </div>
                  日生效
                </div>
                <div v-for="(v, i) in details.dateConfigRange" :key="i">
                  {{ v.promotionStartTime }} 至 {{ v.promotionEndTime }}
                </div>
              </div>
            </div>
          </li>
          <li class="flex">
            <div class="title">参与门店</div>
            <div class="content flex-1">
              <!-- <div
                v-if="
                  details.pasOutlets.length === 1 &&
                    details.pasOutlets[0].outletId === '0'
                "
              >
                全部门店
              </div> -->
              <div>
                <shop-picker
                  readonly
                  :available-shops="outletShops"
                  :selected-shops="outletShops"
                  label=""
                />
              </div>
            </div>
          </li>
          <li class="flex">
            <div class="title">销售渠道</div>
            <div class="content">
              <div v-for="(v, i) in details.platformModels" :key="i">
                {{ v.platformName }}
              </div>
            </div>
          </li>
          <li class="flex">
            <div class="title">促销标签</div>
            <div class="content flex">
              <el-tag v-for="(v, i) in details.pasLabels" :key="i"
                >{{ v.labelKey }}
              </el-tag>
            </div>
          </li>
          <li class="flex">
            <div class="title">会员群组</div>
            <div class="content">
              <!-- <div
                v-if="
                  details.memberGroupList.length === 1 &&
                    details.memberGroupList[0].groupId === '0'
                "
              >
                全部会员群组
              </div> -->
              <div v-for="(v, i) in details.memberGroupList" :key="i">
                {{ v.groupName }}
              </div>
            </div>
          </li>
          <li class="flex" v-if="$route.query.parentId === 'SpecialPrice'">
            <div class="title">Plus标签</div>
            <div class="content">
              {{ details.basicConfigInfo.plusTag === "yes" ? "开启" : "关闭" }}
            </div>
          </li>
        </ul>
      </div>
      <div class="goods mb20" v-if="details.pasGoods && details.pasGoods.length">
        <div class="caption">选择商品</div>
        <el-table
          stripe
          border
          :data="details.pasGoods"
          style="width: 100%"
          id="table"
          size="small"
        >
          <el-table-column
            type="index"
            width="50"
            label="序号"
          ></el-table-column>
          <el-table-column show-overflow-tooltip label="商品货号/条码">
            <template slot-scope="scope">
              <div v-if="scope.row.attrType === 'goods'">
                货号:{{ scope.row.attrId }}
              </div>
              <div v-else-if="scope.row.attrType === 'barcode'">
                条码:{{ scope.row.attrId }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="attrValue"
            label="商品名称"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="shopPrice"
            label="零售价"
          ></el-table-column>
          <el-table-column header-align="center" align="center" label="状态">
            <template slot-scope="scope">
              <span
                v-if="scope.row.useable === 'white' || !scope.row.useable"
                class="select-type white"
                >白</span
              >
              <span
                v-if="scope.row.useable === 'black'"
                class="select-type black"
                >黑</span
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="rule mb20">
        <div class="caption">创建规则</div>
        <ul>
          <li class="flex">
            <div class="title" style="width: 56px">促销类型</div>
            <!-- 满减 -->
            <div
              class="content"
              v-if="
                details.fullReductionRule && details.fullReductionRule.length
              "
            >
              <div
                v-for="(v, i) in details.fullReductionRule"
                :key="i"
                class="flex"
              >
                <div class="mr10">
                  每买满
                  <span class="primary">{{ v.calcCondition }}</span>
                  <span
                    v-if="
                      details.basicConfigInfo.promotionCode.split('-')[1] ===
                        'NumReduction'
                    "
                    >件</span
                  >
                  <span
                    v-if="
                      details.basicConfigInfo.promotionCode.split('-')[1] ===
                        'PriceReduction'
                    "
                    >元</span
                  >
                </div>
                <div class="mr10">
                  减<span class="primary">{{ v.discountResult }}</span
                  >元
                </div>
                <div>
                  最多循环<span class="primary">{{ v.cyclesTimes }}</span
                  >次
                </div>
              </div>
            </div>
            <!-- 满折 -->
            <div
              class="content"
              v-if="details.fullDiscountRule && details.fullDiscountRule.length"
            >
              <div>
                <span v-show="discountMode === 'floorPriceDiscount'"
                  >最低价打折</span
                >
                <span v-show="discountMode === 'fullPriceDiscount'"
                  >整单打折</span
                >
              </div>
              <div v-for="(v, i) in details.fullDiscountRule" :key="i">
                <div class="mr10">
                  每买满<span class="primary">{{ v.purchasesAmount }}</span>
                  <span
                    class="mr10"
                    v-if="
                      details.basicConfigInfo.promotionCode.split('-')[1] ===
                        'NumDiscount'
                    "
                    >件</span
                  >
                  <span
                    class="mr10"
                    v-if="
                      details.basicConfigInfo.promotionCode.split('-')[1] ===
                        'PriceDiscount'
                    "
                    >元</span
                  >
                  <span v-show="discountMode === 'floorPriceDiscount'"
                    >最低价商品</span
                  >打<span class="primary">{{ v.discountRatio }}</span
                  >折
                </div>
              </div>
            </div>
            <!-- 满送 -->
            <div class="content flex-1" v-if="details.fullDeliveryRule">
              <div class="flex">
                <div class="mr10">
                  捆绑方式<span class="primary">{{
                    details.fullDeliveryRule.selectType === "mix"
                      ? "混合"
                      : "同品"
                  }}</span>
                </div>
                <div
                  class="mr10"
                  v-if="details.fullDeliveryRule.selectType !== 'same'"
                >
                  赠送商品价格<span
                    class="primary"
                    v-show="details.giftLimit === 'yes'"
                    >买高送低</span
                  >
                  <span class="primary" v-show="details.giftLimit === 'no'"
                    >不限</span
                  >
                </div>
                <!-- 赠送同品模式 -->
                <div class="mr10">
                  每买满<span class="primary"
                    >{{ details.fullDeliveryRule.purchasesAmount }}
                  </span>
                  <span
                    v-if="
                      details.basicConfigInfo.promotionCode.split('-')[1] ===
                        'NumDelivery'
                    "
                    >件</span
                  >
                  <span
                    v-if="
                      details.basicConfigInfo.promotionCode.split('-')[1] ===
                        'PriceDelivery'
                    "
                    >元</span
                  >
                </div>
                <div
                  class="flex"
                  v-if="details.fullDeliveryRule.selectType === 'same'"
                >
                  <div class="mr10">
                    <!-- 送必选商品<span class="primary">{{details.fullDeliveryRule.mustDeliveryAmount}}</span>件 -->
                    送必选同品如下
                  </div>
                  <!-- <div>
                    送同品<span class="primary">{{
                      details.selectLowerLimit
                    }}</span
                    >件
                  </div> -->
                </div>
              </div>
              <!-- 赠送同品模式 -->
              <div v-if="details.fullDeliveryRule.selectType === 'same'">
                <el-table
                  stripe
                  :data="details.deleveryGoods"
                  style="width: 100%"
                  id="table"
                  border
                  size="small"
                >
                  <el-table-column
                    type="index"
                    width="50"
                    label="序号"
                  ></el-table-column>
                  <el-table-column
                    width="200px"
                    show-overflow-tooltip
                    label="商品货号/条码"
                  >
                    <template slot-scope="scope">
                      {{
                        scope.row.attrType === "barcode"
                          ? `条码：${scope.row.barcode}`
                          : `货号：${scope.row.goodsSn}`
                      }}
                    </template>
                  </el-table-column>
                  <el-table-column
                    header-align="center"
                    align="center"
                    prop="goodsName"
                    label="商品名称"
                  ></el-table-column>
                  <el-table-column
                    header-align="center"
                    align="center"
                    prop="goodsPrice"
                    label="零售价"
                  ></el-table-column>
                  <el-table-column
                    header-align="center"
                    align="center"
                    prop="goodsPackageNum"
                    label="商品数量"
                  ></el-table-column>
                  <el-table-column
                    header-align="center"
                    align="center"
                    prop="selectUpperLimit"
                    label="赠送上限"
                  ></el-table-column>
                  <!-- <el-table-column header-align="center"
                                   align="center"
                                   prop="isMustDelivery"
                                   label="状态">
                    <template slot-scope="scope">
                      <span class="success"
                            v-show="scope.row.isMustDelivery === 'yes'">必选</span>
                      <span class="danger"
                            v-show="scope.row.isMustDelivery === 'no'">可选</span>
                    </template>
                  </el-table-column> -->
                </el-table>
              </div>
              <!-- 赠送混合模式 -->
              <div v-if="details.fullDeliveryRule.selectType === 'mix'">
                <div v-for="(v, i) in details.fullDeliveryGoods" :key="i">
                  <div class="mb20 flex">
                    <div>
                      <span v-if="i > 0">加</span>送可选商品<span
                        class="primary"
                        >{{ v.selectLowerLimit }}</span
                      >件
                    </div>
                  </div>
                  <el-table
                    stripe
                    :data="v.groupGoods"
                    style="width: 100%"
                    id="table"
                    border
                    size="small"
                  >
                    <el-table-column
                      type="index"
                      width="50"
                      label="序号"
                    ></el-table-column>
                    <el-table-column
                      header-align="center"
                      align="center"
                      prop="goodsSn"
                      label="商品货号"
                    ></el-table-column>
                    <el-table-column
                      header-align="center"
                      align="center"
                      prop="goodsName"
                      label="商品名称"
                    ></el-table-column>
                    <el-table-column
                      header-align="center"
                      align="center"
                      prop="goodsPrice"
                      label="零售价"
                    ></el-table-column>
                    <el-table-column
                      header-align="center"
                      align="center"
                      prop="goodsPackageNum"
                      label="商品数量"
                    ></el-table-column>
                    <el-table-column
                      header-align="center"
                      align="center"
                      prop="selectUpperLimit"
                      label="赠送上限"
                    ></el-table-column>
                    <!-- <el-table-column header-align="center"
                                    align="center"
                                    prop="isMustDelivery"
                                    label="状态">
                      <template slot-scope="scope">
                        <span class="success"
                              v-show="scope.row.isMustDelivery === 'yes'">必选</span>
                        <span class="danger"
                              v-show="scope.row.isMustDelivery === 'no'">可选</span>
                      </template>
                    </el-table-column> -->
                  </el-table>
                </div>
              </div>
            </div>
            <!-- 满送叠加 -->
            <div
              class="content flex-1"
              v-if="details.fullDeliveryOverlayRuleModel"
            >
              <div class="flex">
                <div class="mr10">
                  叠加方式
                  <span class="primary" v-if="overlayType === 'ladder'">
                    阶梯
                  </span>
                  <span class="primary" v-else-if="overlayType === 'cycle'">
                    循环
                  </span>
                  <span class="primary" v-if="overlayType === 'no'">
                    不叠加
                  </span>
                </div>
                <div class="mr10">
                  捆绑方式<span class="primary">{{
                    details.fullDeliveryOverlayRuleModel.selectType === "mix"
                      ? "混合"
                      : "同品"
                  }}</span>
                </div>
                <div
                  class="mr10"
                  v-if="
                    details.fullDeliveryOverlayRuleModel.selectType !== 'same'
                  "
                >
                  赠送商品价格
                  <span
                    class="primary"
                    v-show="
                      details.fullDeliveryOverlayRuleModel.giftLimit === 'yes'
                    "
                    >买高送低</span
                  >
                  <span
                    class="primary"
                    v-show="
                      details.fullDeliveryOverlayRuleModel.giftLimit === 'no'
                    "
                    >不限</span
                  >
                </div>
                <!-- 赠送同品模式 -->
                <div class="mr10" v-if="overlayType !== 'ladder'">
                  每买满
                  <span class="primary" v-if="details.fullDeliveryOverlayRuleModel && details.fullDeliveryOverlayRuleModel.overlayRuleModelList">
                    {{
                      details.fullDeliveryOverlayRuleModel
                        .overlayRuleModelList[0].purchasesAmount
                    }}
                  </span>
                  <span
                    v-if="
                      details.basicConfigInfo.promotionCode && details.basicConfigInfo.promotionCode.split('-')[1] ===
                        'NumDeliveryOverlay'
                    "
                    >件</span
                  >
                  <span
                    v-if="
                      details.basicConfigInfo.promotionCode && details.basicConfigInfo.promotionCode.split('-')[1] ===
                        'PriceDeliveryOverlay'
                    "
                    >元</span
                  >
                </div>
                <div
                  class="flex"
                  v-if="
                    details.fullDeliveryOverlayRuleModel.selectType ===
                      'same' &&
                      details.fullDeliveryOverlayRuleModel.overlayType === 'no'
                  "
                >
                  <div class="mr10">
                    <!-- 送必选商品<span class="primary">{{details.fullDeliveryRule.mustDeliveryAmount}}</span>件 -->
                    送必选同品如下
                  </div>
                  <!-- <div>/
                    送同品
                    <span class="primary">{{
                      details.fullDeliveryOverlayRuleModel
                        .overlayRuleModelList[0].sendNum
                    }}</span
                    >件
                  </div> -->
                </div>
                <div
                  class="flex"
                  v-else-if="
                    details.fullDeliveryOverlayRuleModel.selectType ===
                      'same' && overlayType === 'cycle'
                  "
                >
                  <div class="mr10">
                    送同品
                    <span class="primary" v-if="details.fullDeliveryOverlayRuleModel && details.fullDeliveryOverlayRuleModel.overlayRuleModelList">{{
                      details.fullDeliveryOverlayRuleModel
                        .overlayRuleModelList[0].sendNum
                    }}</span
                    >组,
                  </div>
                  <div class="mr10">
                    每组必送同品
                    <span class="primary" v-if="details.fullDeliveryGoods">{{
                      details.fullDeliveryGoods[0].selectLowerLimit
                    }}</span
                    >件,
                  </div>
                  <div>
                    单笔最多送
                    <span class="primary" v-if="details.fullDeliveryOverlayRuleModel && details.fullDeliveryOverlayRuleModel.overlayRuleModelList">{{
                      details.fullDeliveryOverlayRuleModel
                        .overlayRuleModelList[0].maxCycleTimes
                    }}</span
                    >件,
                  </div>
                  超出部分不赠送
                </div>
                <div
                  class="flex"
                  v-else-if="
                    details.fullDeliveryOverlayRuleModel.selectType === 'mix' &&
                      details.fullDeliveryOverlayRuleModel.overlayType ===
                        'cycle'
                  "
                >
                  <div class="mr10">
                    送如下商品
                    <span class="primary" v-if="details.fullDeliveryOverlayRuleModel && details.fullDeliveryOverlayRuleModel.overlayRuleModelList">{{
                      details.fullDeliveryOverlayRuleModel
                        .overlayRuleModelList[0].sendNum
                    }}</span
                    >组, 每组送可选商品
                    <span class="primary" v-if="details.fullDeliveryGoods">{{
                      details.fullDeliveryGoods[0].selectLowerLimit
                    }}</span
                    >件，
                  </div>
                  <div>
                    单笔最多送
                    <span class="primary" v-if="details.fullDeliveryOverlayRuleModel && details.fullDeliveryOverlayRuleModel.overlayRuleModelList">{{
                      details.fullDeliveryOverlayRuleModel
                        .overlayRuleModelList[0].maxCycleTimes
                    }}</span
                    >组,
                  </div>
                  超出部分不赠送
                </div>
              </div>
              <!-- 阶梯叠加规则 -->
              <div
                class="way flex"
                v-if="
                  overlayType === 'ladder' &&
                    details.fullDeliveryOverlayRuleModel.overlayRuleModelList
                      .length
                "
              >
                <div>
                  <div
                    class="way-item flex item-center"
                    v-for="(v, i) in details.fullDeliveryOverlayRuleModel
                      .overlayRuleModelList"
                    :key="i"
                  >
                    买满
                    <div style="width: 80px" class="text-center">
                      {{ v.purchasesAmount }}
                    </div>
                    <span v-if="childId === 'PriceDeliveryOverlay'">元</span>
                    <span v-if="childId === 'NumDeliveryOverlay'">件</span>，
                    <div>
                      {{ selectType === "same" ? "必送同品" : "选送如下商品" }}
                    </div>
                    <div style="width: 80px" class="text-center">
                      {{ v.sendNum }}
                    </div>
                    组
                  </div>
                </div>
                <div class="flex flex-center item-center ml10">
                  {{ selectType === "same" ? "每组必送同品" : "每组选送" }}
                  <span v-if="details.fullDeliveryGoods">{{ details.fullDeliveryGoods[0].selectLowerLimit }}</span> 件
                </div>
              </div>
              <!-- 赠送同品模式 -->
              <div
                v-if="
                  details.fullDeliveryOverlayRuleModel.selectType === 'same'
                "
              >
                <el-table
                  stripe
                  :data="details.deleveryGoods"
                  style="width: 100%"
                  id="table"
                  border
                  size="small"
                >
                  <el-table-column
                    type="index"
                    width="50"
                    label="序号"
                  ></el-table-column>
                  <el-table-column
                    width="200px"
                    show-overflow-tooltip
                    label="商品货号/条码"
                  >
                    <template slot-scope="scope">
                      {{
                        scope.row.attrType === "barcode"
                          ? `条码：${scope.row.barcode}`
                          : `货号：${scope.row.goodsSn}`
                      }}
                    </template>
                  </el-table-column>
                  <el-table-column
                    header-align="center"
                    align="center"
                    prop="goodsName"
                    label="商品名称"
                  ></el-table-column>
                  <el-table-column
                    header-align="center"
                    align="center"
                    prop="goodsPrice"
                    label="零售价"
                  ></el-table-column>
                  <el-table-column
                    header-align="center"
                    align="center"
                    prop="goodsPackageNum"
                    label="商品数量"
                  ></el-table-column>
                  <el-table-column
                    header-align="center"
                    align="center"
                    prop="selectUpperLimit"
                    label="赠送上限"
                  ></el-table-column>
                  <!-- <el-table-column header-align="center"
                                   align="center"
                                   prop="isMustDelivery"
                                   label="状态">
                    <template slot-scope="scope">
                      <span class="success"
                            v-show="scope.row.isMustDelivery === 'yes'">必选</span>
                      <span class="danger"
                            v-show="scope.row.isMustDelivery === 'no'">可选</span>
                    </template>
                  </el-table-column> -->
                </el-table>
              </div>
              <!-- 赠送混合模式 -->
              <div
                v-if="details.fullDeliveryOverlayRuleModel.selectType === 'mix'"
              >
                <div v-for="(v, i) in details.fullDeliveryGoods" :key="i">
                  <div
                    class="mb20 flex"
                    v-if="
                      details.fullDeliveryOverlayRuleModel.overlayType === 'no'
                    "
                  >
                    <div>
                      <span v-if="i > 0">加</span>送可选商品
                      <span class="primary">{{ v.selectLowerLimit }}</span
                      >件
                    </div>
                  </div>
                  <el-table
                    stripe
                    :data="v.groupGoods"
                    style="width: 100%"
                    id="table"
                    border
                    size="small"
                  >
                    <el-table-column
                      type="index"
                      width="50"
                      label="序号"
                    ></el-table-column>
                    <el-table-column
                      header-align="center"
                      align="center"
                      prop="goodsSn"
                      label="商品货号"
                    ></el-table-column>
                    <el-table-column
                      header-align="center"
                      align="center"
                      prop="goodsName"
                      label="商品名称"
                    ></el-table-column>
                    <el-table-column
                      header-align="center"
                      align="center"
                      prop="goodsPrice"
                      label="零售价"
                    ></el-table-column>
                    <el-table-column
                      header-align="center"
                      align="center"
                      prop="goodsPackageNum"
                      label="商品数量"
                    ></el-table-column>
                    <el-table-column
                      header-align="center"
                      align="center"
                      prop="selectUpperLimit"
                      label="赠送上限"
                    ></el-table-column>
                    <!-- <el-table-column header-align="center"
                                    align="center"
                                    prop="isMustDelivery"
                                    label="状态">
                      <template slot-scope="scope">
                        <span class="success"
                              v-show="scope.row.isMustDelivery === 'yes'">必选</span>
                        <span class="danger"
                              v-show="scope.row.isMustDelivery === 'no'">可选</span>
                      </template>
                      </el-table-column>-->
                  </el-table>
                </div>
              </div>
            </div>
            <!-- 加价购 -->
            <div class="content flex-1" v-if="details.increasePurchaseRules">
              <div
                class="mb20"
                v-for="(v, i) in details.increasePurchaseRules"
                :key="i"
              >
                <div class="flex mb20">
                  <div class="item mr20">
                    每买满 <span class="primary">{{ v.purchasesAmount }}</span>
                    <span
                      v-if="
                        details.basicConfigInfo.promotionCode.split('-')[1] ===
                          'NumIncrease'
                      "
                    >
                      件
                    </span>
                    <span
                      v-if="
                        details.basicConfigInfo.promotionCode.split('-')[1] ===
                          'PriceIncrease'
                      "
                    >
                      元
                    </span>
                  </div>
                  <div class="item mr20">
                    加<span class="primary">{{ v.markupFee }}</span
                    >元
                  </div>
                  <div class="item mr20 flex item-center">
                    换购<span class="primary">{{
                      v.exchangePurchasesUpperAmount
                    }}</span
                    >件
                  </div>
                </div>
                <!-- 加价购赠送商品 -->
                <el-table
                  :data="v.purchaseGoodsList"
                  size="mini"
                  stripe
                  border
                  style="width: 100%"
                >
                  <el-table-column
                    prop="goodsSn"
                    header-align="center"
                    align="center"
                    label="货号"
                  >
                  </el-table-column>
                  <el-table-column
                    prop="goodsName"
                    header-align="center"
                    align="center"
                    label="商品名"
                  >
                  </el-table-column>
                  <el-table-column
                    prop="goodsPackageNum"
                    header-align="center"
                    align="center"
                    label="商品数量"
                  >
                  </el-table-column>
                  <el-table-column
                    prop="selectUpperLimit"
                    header-align="center"
                    align="center"
                    label="换购上限"
                  >
                  </el-table-column>
                </el-table>
              </div>
            </div>
            <!-- 组合价 -->
            <div class="content flex-1" v-if="details.combinationPriceGoods">
              <div
                class="flex mb20"
                v-for="(v, i) in details.combinationPriceRules"
                :key="i"
              >
                <div class="item mr20">
                  每买满 <span class="primary">{{ v.purchasesAmount }}</span
                  >件
                </div>
                <div class="item mr20">
                  组合价<span class="primary">{{ v.combinationPrice }}</span
                  >元
                </div>
              </div>
              <el-table
                :data="details.combinationPriceGoods"
                size="mini"
                stripe
                border
                style="width: 100%"
              >
                <el-table-column
                  width="200px"
                  show-overflow-tooltip
                  label="商品货号/条码"
                >
                  <template slot-scope="scope">
                    {{
                      scope.row.attrType === "barcode"
                        ? `条码：${scope.row.barcode}`
                        : `货号：${scope.row.goodsSn}`
                    }}
                  </template>
                </el-table-column>
                <el-table-column
                  prop="goodsName"
                  header-align="center"
                  align="center"
                  label="商品名"
                >
                </el-table-column>
                <el-table-column
                  prop="goodsPackageNum"
                  header-align="center"
                  align="center"
                  label="商品数量"
                >
                </el-table-column>
                <el-table-column
                  prop="selectUpperLimit"
                  header-align="center"
                  align="center"
                  label="换购上限"
                >
                </el-table-column>
              </el-table>
            </div>
            <!-- 特价 -->
            <div class="content flex-1" v-if="details.listHot">
              <div class="flex flex-end">
                <el-button
                  type="primary"
                  @click="output('特价促销商品')"
                  :loading="isOutputing"
                  size="small"
                  >导出数据</el-button
                >
              </div>
              <el-table
                :data="details.listHot"
                size="mini"
                ref="table"
                stripe
                border
                style="width: 100%"
                :max-height="400"
              >
                <el-table-column
                  width="200px"
                  show-overflow-tooltip
                  prop="goodinfo"
                  label="商品货号/条码"
                >
                  <template slot-scope="scope">
                    {{
                      scope.row.attrType === "barcode"
                        ? `条码：${scope.row.barcode}`
                        : `货号：${scope.row.goodsSn}`
                    }}
                  </template>
                </el-table-column>
                <el-table-column
                  prop="goodsName"
                  header-align="center"
                  align="center"
                  show-overflow-tooltip
                  label="商品名"
                >
                </el-table-column>
                <el-table-column
                  prop="goodsPackageNum"
                  header-align="center"
                  align="center"
                  label="商品数量"
                >
                </el-table-column>
                <el-table-column
                  prop="shopPrice"
                  header-align="center"
                  align="center"
                  label="商品价格"
                >
                </el-table-column>
                <el-table-column
                  prop="totalStockNum"
                  header-align="center"
                  align="center"
                  label="促销库存"
                >
                </el-table-column>
                <el-table-column
                  prop="purchasesUpperLimit"
                  header-align="center"
                  align="center"
                  label="单人限购"
                >
                </el-table-column>
                <el-table-column
                  prop="discountRatio"
                  header-align="center"
                  align="center"
                  label="折扣比率(折)"
                >
                  <template slot-scope="scope">
                    {{ scope.row.discountRatio }}折
                  </template>
                </el-table-column>
                <el-table-column
                  prop="discountPrice"
                  header-align="center"
                  align="center"
                  label="折扣金额"
                >
                </el-table-column>
              </el-table>
            </div>
            <!--叠加赠送-->
            <div class="content flex-1" v-if="details.pasSuperpositionGiftRuleLimitModel">
              <div class="flex">
                <div class="mr10">
                  叠加<span class="primary">{{
                    details.pasSuperpositionGiftRuleLimitModel.giftMode === "num"
                      ? "按数量"
                      : "按金额"
                  }}</span>
                </div>
                <div class="mr10">
                  单件商品满<span class="primary"
                    >{{ details.pasSuperpositionGiftRuleLimitModel.purchasesAmount }}
                  </span>
                  <span
                    v-if="
                      details.basicConfigInfo.promotionCode.split('-')[1] ===
                        'NumDeliveryGift'
                    "
                    >件</span
                  >
                  <span
                    v-if="
                      details.basicConfigInfo.promotionCode.split('-')[1] ===
                        'PriceDeliveryGift'
                    "
                    >元</span
                  >
                  件循环赠送以下商品,并且用户无需选择
                </div>                
              </div>              
              <div>       
                <el-table
                  stripe
                  :data="details.pasSuperpositionGiftRuleGoodsModelList"
                  style="width: 100%"
                  id="table"
                  border
                  size="small"
                >
                  <el-table-column
                    type="index"
                    width="50"
                    label="序号"
                  ></el-table-column>
                  <el-table-column
                    header-align="center"
                    align="center"
                    prop="goodsSn"
                    label="商品货号"
                  ></el-table-column>
                  <el-table-column
                    header-align="center"
                    align="center"
                    prop="goodsName"
                    label="商品名称"
                  ></el-table-column>
                  <el-table-column
                    header-align="center"
                    align="center"
                    prop="wxshopPrice"
                    label="零售价"
                  ></el-table-column>
                  <el-table-column
                    header-align="center"
                    align="center"
                    prop="giftNum"
                    label="赠送数量"
                  ></el-table-column>
                  <el-table-column
                    header-align="center"
                    align="center"
                    prop="giftUpperLimitNum"
                    label="单笔订单赠送上限"
                  ></el-table-column>
                </el-table>
              </div>
            </div>
          </li>
        </ul>
      </div>
      <div class="rule mb20" v-if="details.pasSuperpositionGiftRelationPromotionModels">
        <div class="caption">关联活动</div>
        <ul>
          <li>
            <el-table
              stripe
              border
              :data="details.pasSuperpositionGiftRelationPromotionModels"
              style="width: 100%"
              id="connectedTable"
              ref="connectedTable"
              size="small"
            >
              <el-table-column
                header-align="center"
                align="center"
                type="index"
                label="序号"
                :index="
                  (index) => index + (currentPage - 1) * pageSize + 1
                "
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="promotionName"
                label="促销名称"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="type"
                label="促销类型"
              >
                <template slot-scope="scope">
                  {{ scope.row.typeName }}
                </template>
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="promotionStartTime"
                label="促销时间"
              >
                <template slot-scope="scope">
                  <span class="time">
                    {{ scope.row.promotionStartTime }}至{{ scope.row.promotionEndTime }}
                  </span>
                </template>
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="enabledState"
                label="促销状态"
              >
                <template slot-scope="scope">
                  <span
                    class="status danger"
                    v-show="scope.row.enabledState === 'disabled'"
                    >下线</span
                  >
                  <span
                    class="status success"
                    v-show="scope.row.enabledState === 'enable'"
                    >上线</span
                  >
                </template>
              </el-table-column>
            </el-table>
          </li>
        </ul>
      </div>  
    </div>
    <div class="btn-wrapper flex flex-center">
      <el-button
        size="small"
        type="primary"
        v-if="isWaitAudit && !mode"
        @click="switchAuditState('audit_pass')"
        >通过</el-button
      >
      <el-button
        size="small"
        type="primary"
        v-if="isWaitAudit && !mode"
        @click="switchAuditState('reject')"
        >驳回</el-button
      >
      <el-button size="small" @click="back">返回</el-button>
    </div>
    <el-dialog
      title="驳回当前促销?"
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      width="600px"
    >
      <el-form label-width="80px">
        <el-form-item label="驳回原因">
          <el-input
            maxlength="100"
            size="small"
            type="textarea"
            v-model="reason"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer flex flex-center">
        <el-button @click="submitRuleForm" size="small" type="primary"
          >保存</el-button
        >
        <el-button @click="dialogVisible = false" size="small">关闭</el-button>
      </span>
    </el-dialog>
  </hm-content>
</template>

<script>
import { mapGetters } from "vuex";
import { ShopPicker } from "@/components/shop-picker";
export default {
  data() {
    return {
      isOutputing: false,
      reason: "",
      mode: "",
      dialogVisible: false,
      previewDiaogVisible: false,
      keyWord: "",
      discountMode: "",
      storeOutletId: "",
      serverId: "",
      status: "",
      currentPage: 1,
      startDate: "",
      endDate: "",
      dateAndTime: "",
      pageSize: 10,
      isWaitAudit: false,
      id: "",
      btnList: [
        { name: "全部" },
        { name: "已预约" },
        { name: "已付款" },
        { name: "消费中" },
        { name: "服务结束" },
        { name: "取消预约" },
        { name: "已驳回" }
      ],
      details: {
        basicConfigInfo: {},
        dateConfigInfo: {},
        dateConfigRange: {},
        fullDeliveryOverlayRuleModel: {},
        fullDiscountRule: [],
        pasCalendars: [],
        pasGoods: [],
        pasLabels: [],
        pasOutlets: []
      },
      couponLevelList: [],
      pasLevelName: "",
      childId: ""
    };
  },
  mounted() {
    const { type, id, parentId, mode } = this.$route.query;
    this.id = id;
    this.mode = mode;

    this.isWaitAudit = type === "wait_audit";

    switch (parentId) {
      case "FullDiscount":
        this.$store.dispatch("queryFullDiscountDetails", {
          id,
          parentId
        });
        break;
      case "FullReduction":
        this.$store.dispatch("queryFullReductionDetails", {
          id,
          parentId
        });
        break;
      case "FullDelivery":
        this.$store.dispatch("queryFullDelivertDetails", {
          id,
          parentId
        });
        break;
      case "FullDeliveryOverlay":
        this.$store.dispatch("queryFullDelivertDetailsOverlay", {
          id,
          parentId
        });
        break;
      case "IncreasePurchase":
        this.$store.dispatch("queryIncreasePurchaseDetails", {
          id,
          parentId
        });
        break;
      case "CombinationPrice":
        this.$store.dispatch("queryCombinationDetails", {
          id,
          parentId
        });
        break;
      case "SpecialPrice":
        this.$store.dispatch("querySpecialRuleDetails", {
          id,
          parentId
        });
        break;
      case "SuperpositionGift":
        this.$store.dispatch("querySuperpositionGift", {
          id,
          parentId
        }).then(res=>{
          this.details = res.result;
        });
        break;  
      default:
        break;
    }
  },
  computed: {
    ...mapGetters([
    "fullDiscountDetails",
    "fullReductionDetails",
    "fullDeliveruDetails",
    "fullDeliveruDetailsOverlay",
    "selectType",
    "overlayType",
    "fullIncreasePurchaseDetails",
    "combinationDetails",
    "specialRuleDetails",
  ]),
    // 参与门店：pasOutlets 为 [{outletId, outletName}]，映射为 ShopPicker 需要的 {shopId, shopName}
    outletShops() {
      return (this.details.pasOutlets || []).map(item => ({
        shopId: item.outletId,
        shopName: item.outletName
      }));
    }
  },
  watch: {
    specialRuleDetails(val) {
      this.details = val;
    },
    fullDiscountDetails(val) {
      this.details = val;
      this.details.fullDiscountRule.map(v => {
        this.discountMode = v.discountMode;
      });
      this.queryCouponLevelList();
    },
    fullReductionDetails(val) {
      this.details = val;
      this.queryCouponLevelList();
    },
    fullDeliveruDetailsOverlay(val) {
      if (this.selectType === "same") {
        val.deleveryGoods = [];
        val.selectLowerLimit = val.fullDeliveryGoods[1]
          ? val.fullDeliveryGoods[1].selectLowerLimit
          : 0;
        val.giftLimit = val.fullDeliveryGoods[0]
          ? val.fullDeliveryGoods[0].giftLimit
          : "yes";
        val.fullDeliveryGoods.map(o => {
          val.deleveryGoods = val.deleveryGoods.concat(o.groupGoods);
        });
        this.details = val;
      } else if (this.selectType === "mix") {
        val.giftLimit = val.fullDeliveryGoods[0]
          ? val.fullDeliveryGoods[0].giftLimit
          : "yes";
        val.fullDeliveryGoods.forEach(v => {
          v.groupGoods.forEach(o => {
            if (o.typeId && o.typeValue) {
              o.goodsSn = o.typeId;
              o.goodsName = o.typeValue;
            }
          });
        });

        this.details = val;
        this.queryCouponLevelList();
      }
      this.childId = val.basicConfigInfo.promotionCode.split("-")[1];
    },
    fullDeliveruDetails(val) {
      if (this.selectType === "same") {
        val.deleveryGoods = [];
        val.selectLowerLimit = val.fullDeliveryGoods[1]
          ? val.fullDeliveryGoods[1].selectLowerLimit
          : 0;
        val.giftLimit = val.fullDeliveryGoods[0]
          ? val.fullDeliveryGoods[0].giftLimit
          : "yes";
        val.fullDeliveryGoods.map(o => {
          val.deleveryGoods = val.deleveryGoods.concat(o.groupGoods);
        });
        this.details = val;
      } else if (this.selectType === "mix") {
        val.giftLimit = val.fullDeliveryGoods[0]
          ? val.fullDeliveryGoods[0].giftLimit
          : "yes";
        val.fullDeliveryGoods.forEach(v => {
          v.groupGoods.forEach(o => {
            if (o.typeId && o.typeValue) {
              o.goodsSn = o.typeId;
              o.goodsName = o.typeValue;
            }
          });
        });

        this.details = val;
        this.queryCouponLevelList();
      }
    },
    fullIncreasePurchaseDetails(val) {
      this.details = val;
      this.queryCouponLevelList();
    },
    combinationDetails(val) {
      this.details = val;
    }
  },
  methods: {
    // 导出excel
    output(title) {
      require.ensure([], () => {
        const { exportJsonToExcel } = require("@/utils/output/Export2Excel");
        this.isOutputing = true;
        let list = JSON.parse(JSON.stringify(this.details.listHot));
        list.forEach(v => {
          v.goodinfo =
            v.attrType === "barcode"
              ? `条码：${v.barcode}`
              : `货号：${v.goodsSn}`;
        });
        const tHeader = this.$refs.table.columns
          .map(o => o.label !== "序号" && o.label !== "操作" && o.label)
          .filter(o => o);
        let filterVal = [];
        if (list.length > 0) {
          filterVal = this.$refs.table.$children
            .map(o => o._props.prop)
            .filter(o => o);
        }
        const data = this.formatJson(filterVal, list);
        exportJsonToExcel(tHeader, data, title + new Date().toLocaleString());
        this.isOutputing = false;
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]));
    },
    async queryCouponLevelList() {
      let params = {
        dictCode: "pas_level"
      };
      const { result } = await this.$store.dispatch("queryPasList", params);
      if (result) {
        const { sysDictItem } = result;

        this.couponLevelList = sysDictItem;

        this.pasLevelName = this.couponLevelList.find(
          o => o.itemValue == this.details.basicConfigInfo.pasLevel
        ).itemText;
      }
    },
    submitRuleForm() {
      this.$store
        .dispatch("switchAuditState", {
          id: this.id,
          auditState: "reject",
          reason: this.reason
        })
        .then(res => {
          if (res.code === "0") {
            this.$message({
              message: " 操作成功",
              type: "success"
            });
            this.$router.back(-1);
          }
        });
    },
    switchAuditState(auditState) {
      if (auditState === "reject") {
        this.dialogVisible = true;
      } else {
        this.$store
          .dispatch("switchAuditState", {
            id: this.id,
            auditState
          })
          .then(res => {
            if (res.code === "0") {
              this.$message({
                message: " 操作成功",
                type: "success"
              });
              this.$router.back(-1);
            }
          });
      }
    },
    back() {
      this.$router.back(-1);
    }
  },
  components: {
    ShopPicker
  }
};
</script>

<style scoped lang="scss">
.caption {
  position: relative;
  padding-left: 10px;
  color: #000;
  margin-bottom: 20px;
  &::before {
    position: absolute;
    left: 0;
    width: 4px;
    height: 100%;
    background: #e50065;
    content: "";
    border-top-left-radius: 5px;
    border-bottom-right-radius: 5px;
  }
}
.btn.active {
  background: #71abff;
  color: #fff;
  border-radius: 5px;
}
.btn-group {
  margin-bottom: 2rem;
}

.status {
  width: 15px;
  height: 15px;
  border-radius: 50%;
  margin-right: 10px;
}

.detail-container {
  font-size: 14px;
  .title {
    color: #000;
    margin-right: 20px;
  }
  li {
    margin-bottom: 20px;
  }
  .content {
    > div {
      margin-bottom: 10px;
    }
  }
}
</style>
